import React from 'react';
import T from 'prop-types';

const EmptyRow = ({ emptyState, isTableLayout, emptyCellColSpan }) =>
  isTableLayout ? (
    <tr className="b-b empty-row-text">
      <td colSpan={emptyCellColSpan}>
        {typeof emptyState === 'string' ? (
          <div className="state-empty card-simple bg-gray text-quiet text-xxs-center">
            <div className="p-t-lg p-b-lg">
              <p>{emptyState}</p>
            </div>
          </div>
        ) : (
          emptyState
        )}
      </td>
    </tr>
  ) : (
    <div className="d-tr empty-row-text">
      <div className="d-flex w-100">
        {typeof emptyState === 'string' ? (
          <div className="state-empty d-flex w-100  card-simple bg-gray text-quiet text-xxs-center">
            <div className="p-t-lg p-b-lg d-flex w-100">
              <p>{emptyState}</p>
            </div>
          </div>
        ) : (
          emptyState
        )}
      </div>
    </div>
  );

EmptyRow.propTypes = {
  emptyCellColSpan: T.number,
  isTableLayout: T.bool.isRequired,
  emptyState: T.oneOfType([T.string, T.node]).isRequired,
};

export default EmptyRow;
